import { render } from "./001-CompanyEstablishedPage.vue?vue&type=template&id=33c668b1&scoped=true"
import script from "./001-CompanyEstablishedPage.vue?vue&type=script&lang=js"
export * from "./001-CompanyEstablishedPage.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=33c668b1&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c668b1"]])

export default __exports__